import { backendApi } from "./backend.api";
import { ITemplate } from "shared/models/models";
import { getSpaceId } from "shared/utils/space";

interface ITemplateListQuery {
  spaceId?: number;
}

export const templateApi = backendApi.injectEndpoints({
  endpoints: (build) => {
    return {
      templates: build.query<ITemplate[], ITemplateListQuery | null>({
        query: (queryParams) => {
          const spaceId = getSpaceId();
          const params: ITemplateListQuery = { ...queryParams };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: "/template",
            method: "GET",
            params: params,
          };
        },
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: "Template" as const, id })),
                "Template",
              ]
            : ["Template"],
      }),
      getTemplate: build.query<ITemplate, number>({
        query: (id) => ({ url: `/template/${id}`, method: "GET" }),
        transformErrorResponse: (response: { route: string | number }) =>
          response.route,
        providesTags: (item) => [{ type: "Template", id: item?.id }],
      }),
      copyTemplate: build.mutation<ITemplate, number>({
        query: (id) => ({
          url: `/template/${id}/copy`,
          method: "POST",
          data: { id: id },
        }),
        transformErrorResponse: (response: { route: string | number }) =>
          response.route,
        invalidatesTags: () => ["Template"],
        transformResponse: (response: { data: ITemplate }) => response.data,
      }),
      addTemplate: build.mutation<ITemplate, Partial<ITemplate>>({
        query: (payload) => {
          const spaceId = getSpaceId();
          const params: Partial<ITemplate> = { ...payload };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: "/template",
            method: "POST",
            data: params,
          };
        },
        invalidatesTags: () => ["Template"],
        transformResponse: (response: { data: ITemplate }) => response.data,
      }),
      updateTemplate: build.mutation<ITemplate, Partial<ITemplate>>({
        query: (payload) => ({
          url: `/template/${payload.id}`,
          method: "PATCH",
          data: payload,
        }),
        invalidatesTags: (item) => [{ type: "Template", id: item?.id }],
        //transformResponse: (result, error) => [{ type: 'Visit', id: result?.id }],
      }),
      orderTemplate: build.mutation<ITemplate, number>({
        query: (id) => ({
          url: `/template/${id}/order`,
          method: "PATCH",
        }),
        invalidatesTags: (item) => [{ type: "Template", id: item?.id }],
        //transformResponse: (result, error) => [{ type: 'Visit', id: result?.id }],
      }),
      documentTemplate: build.mutation<ITemplate, number>({
        query: (id) => ({
          url: `/template/${id}/document`,
          method: "PATCH",
        }),
        invalidatesTags: (item) => [{ type: "Template", id: item?.id }],
        //transformResponse: (result, error) => [{ type: 'Visit', id: result?.id }],
      }),
      deleteTemplate: build.mutation<ITemplate, number>({
        query: (id) => ({
          url: `/template/${id}`,
          method: "DELETE",
          credentials: "include",
        }),
        invalidatesTags: ["Template"],
      }),
    };
  },
});

export const {
  useTemplatesQuery,
  useAddTemplateMutation,
  useDeleteTemplateMutation,
  useGetTemplateQuery,
  useCopyTemplateMutation,
  useOrderTemplateMutation,
  useDocumentTemplateMutation,
  useUpdateTemplateMutation,
} = templateApi;
